<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
          <li class="active">{{ bannerTopo[0].itiNome }}</li>
        </ol>
      </div>
    </div>
  </section>

  <!--================ contato =================-->
  <section class="contact_area section_gap">
    <div v-if="contato != ''" class="container">
      <div class="row mb-80">

        <!--=== endereço ===-->
        <div class="col-md-3">
          <div class="contact_info">
            <div class="info_item">
              <i class="lnr lnr-home"></i>
              <h6>Endereço</h6>
              <p v-html="contato[0].itiResumo1"></p>
            </div>
            <div class="info_item">
              <i class="lnr lnr-phone-handset"></i>
              <h6>telefone</h6>
              <p><router-link :to="contato[0].itiCampoExtra4">{{ contato[0].itiCampoExtra3 }}</router-link></p>
            </div>
            <div class="info_item">
              <i class="lnr lnr-envelope"></i>
              <h6>E-mail</h6>
              <p>{{ contato[0].itiReferencia }}</p>
            </div>
          </div>
        </div>

        <!--=== formulario ===-->
        <div class="col-md-9">
          <form class="row contact_form" method="post" id="contactForm">
            <div class="col-md-6">
              <div class="form-group">
                <input v-model="formulario.nome" type="text" class="form-control" id="nome" name="nome"
                  placeholder="Nome">
              </div>
              <div class="form-group">
                <input v-model="formulario.email" type="email" class="form-control" id="email" name="email"
                  placeholder="E-mail">
              </div>
              <div class="form-group">
                <input v-mask="'(##) #####-####'" v-model="formulario.telefone" type="text" class="form-control"
                  id="telefone" name="telefone" placeholder="(99) 99999-9999">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <textarea v-model="formulario.mensagem" class="form-control" name="mensagem" id="mensagem" rows="1"
                  placeholder="Escreva sua Mensagem"></textarea>
              </div>
            </div>
            <div class="col-md-12 text-right">
              <button type="submit" @click.prevent="enviaremail()" class="btn theme_btn button_hover">Enviar</button>
            </div>
          </form>
        </div>
      </div>

      <!--=== mapa ===-->
      <div id="mapBox" class="mapBox">
        <iframe v-if="contato != ''"
          :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra6"
          width="100%" height="500px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'ContatoView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      telefone: "",
      mensagem: ""
    }
  }),

  methods: {
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else if (this.formulario.telefone == '' || this.formulario.telefone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Garante Imob",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiReferencia,
          emailResposta: this.formulario.email,
          textoEmail: 
          "Nome: " + this.formulario.nome + "<br>" + 
          "E-mail: " + this.formulario.email + "<br>" +
          "Telefone: " + this.formulario.telefone + "<br>" + 
          "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso("E-mail enviado com sucesso!")
              this.limparFormulario();
            }
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.telefone = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Imob - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

  },

  created() {
    this.carregaMetas("---");

    // bannerTopo
    axios.get('/Process/InsInstitucional/institucional/51/topocontato/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('contato topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // contato
    axios.get('/Process/InsInstitucional/institucional/52/dadosdecontato/0/x')
      .then(response => {
        this.contato = response.data;
        //console.log('contato')
        //console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>